import { createContext } from 'react';
import { DEFAULT_WARBOX_MESSAGE_CONTEXT } from './constants/defaultContext';

export const WarboxMessageContext = createContext(
    DEFAULT_WARBOX_MESSAGE_CONTEXT
);
